module.exports = __webpack_public_path__ + "sq1-2790a1c8.png";